import axios, { AxiosInstance } from "axios";
import Cookies from "js-cookie";

const apiToken =
    "413ad652513c2b0172e59ef9b2efb4b0f254cafe64e37480e764257345ff8d6c";

const handleErrorResponse = (error: any) => {
    const err = error.response?.data ? error.response.data : error;

    if (err.code === 401) {
        window.location.href = window.location.origin + "/logout";
        return;
    }

    return Promise.reject(err);
};

export default abstract class Api {
    private static v1Instance = axios.create({
        baseURL: "https://api-serendipity.oneplay.in/v1",
    });

    private static v2Instance = axios.create({
        baseURL: "https://api-serendipity.oneplay.in/v2/api",
        headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            token: apiToken,
        },
    });

    private static idamInstance = axios.create({
        baseURL: "https://api-serendipity.oneplay.in/idam",
        headers: { "Content-Type": "multipart/form-data" },
    });

    static create() {
        this.v1Instance.interceptors.request.use((request) => {
            let data: FormData = request.data;
            if (!data) {
                data = new FormData();
            }
            data.append("token", apiToken);
            data.append("session-token", Cookies.get("token") ?? "");
            return request;
        });

        this.idamInstance.interceptors.request.use((request) => {
            let data: FormData = request.data;
            if (!data) {
                data = new FormData();
            }
            data.append("token", apiToken);
            data.append("session-token", "AUTH");
            data.append("device", "web");
            return request;
        });

        this.v2Instance.interceptors.request.use((request) => {
            request.headers["session_token"] = Cookies.get("token") ?? "";
            return request;
        });

        this.v1Instance.interceptors.response.use(
            (res) => res,
            handleErrorResponse
        );

        this.v2Instance.interceptors.response.use(
            (res) => res,
            handleErrorResponse
        );
    }

    public static get v1AxiosInstance() {
        return this.v1Instance;
    }

    public static get v2AxiosInstance() {
        return this.v2Instance;
    }

    public static get idamAxiosInstance() {
        return this.idamInstance;
    }
}

Api.create();
